import { render } from "./FloatingChatWidget.vue?vue&type=template&id=40d34033&scoped=true"
import script from "./FloatingChatWidget.vue?vue&type=script&lang=js"
export * from "./FloatingChatWidget.vue?vue&type=script&lang=js"

import "./FloatingChatWidget.vue?vue&type=style&index=0&id=40d34033&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d34033"]])

export default __exports__